import {Config} from "../models/Config";

const config: Config = {
    apiUrl: "https://api.plus.sporta.digital/",
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '641347128620-dojar4os43pidkb26reipn51rggmajo5.apps.googleusercontent.com'
};
export default config;
